import React from "react";
import NavLink from "react-bootstrap/NavLink";
import '../../assets/scss/error-page.scss';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    componentDidCatch(error) {
        this.setState({ error });
    }

    render() {
        if (this.state.error) {
            return <div className="page">
                <div className="page-content text-center">
                    <h3 className="page-text">Unexpected Error</h3>
                    <NavLink href="/logout">Go to Login</NavLink>
                </div>
            </div>;
        }

        // Render children if there's no error
        return this.props.children;
    }
};